export type MediaType = 'image' | 'audio' | 'movie' | 'website';

export class TaskModuleMediaData {
    constructor(public mediaType: MediaType,
                public mediaUrl: string,
                public imageUrl: string | undefined) {
    }
}
